import v from "./_common.js";
import S from "../../_styles/common/light.js";
function f(C) {
  const {
    textColor2: r,
    primaryColor: o,
    textColorDisabled: t,
    closeIconColor: i,
    closeIconColorHover: s,
    closeIconColorPressed: n,
    closeColorHover: c,
    closeColorPressed: d,
    tabColor: a,
    baseColor: x,
    dividerColor: T,
    fontWeight: l,
    textColor1: e,
    borderRadius: b,
    fontSize: g,
    fontWeightStrong: m
  } = C;
  return Object.assign(Object.assign({}, v), {
    colorSegment: a,
    tabFontSizeCard: g,
    tabTextColorLine: e,
    tabTextColorActiveLine: o,
    tabTextColorHoverLine: o,
    tabTextColorDisabledLine: t,
    tabTextColorSegment: e,
    tabTextColorActiveSegment: r,
    tabTextColorHoverSegment: r,
    tabTextColorDisabledSegment: t,
    tabTextColorBar: e,
    tabTextColorActiveBar: o,
    tabTextColorHoverBar: o,
    tabTextColorDisabledBar: t,
    tabTextColorCard: e,
    tabTextColorHoverCard: e,
    tabTextColorActiveCard: o,
    tabTextColorDisabledCard: t,
    barColor: o,
    closeIconColor: i,
    closeIconColorHover: s,
    closeIconColorPressed: n,
    closeColorHover: c,
    closeColorPressed: d,
    closeBorderRadius: b,
    tabColor: a,
    tabColorSegment: x,
    tabBorderColor: T,
    tabFontWeightActive: l,
    tabFontWeight: l,
    tabBorderRadius: b,
    paneTextColor: r,
    fontWeightStrong: m
  });
}
const h = {
  name: "Tabs",
  common: S,
  self: f
}, u = h;
export {
  u as default,
  f as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/tabs/styles/light.js
// module id = 1703
// module chunks = 41